import PageHeader from "../components/PageHeader";
import Faq from "../components/Faq";

export default function FaqPage() {
  return (
    <>
      <PageHeader
        eyebrow="Common questions"
        title="Questions people ask before booking."
        lead="If yours is not here, message me on WhatsApp — I answer these myself."
      />
      <Faq />
    </>
  );
}
